import React from 'react';

import { H1 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { MediaElement } from '../shared/mediaElement';
import TextBlock from '../shared/TextBlock/TextBlock';

import { BulkTextProps } from './types';

export const OneColumnVariation: React.FC<Omit<BulkTextProps, 'variation'>> = ({
  title,
  textBlock1,
  media,
  textBlock2,
}) => {
  return (
    <FlexColumn gap="32px">
      <FlexColumn gap="16px">
        <H1 bold as="h2">
          {title}
        </H1>
        {textBlock1 && <TextBlock text={textBlock1} />}
      </FlexColumn>
      <MediaElement
        {...media}
        aspectRatio="16/9"
        objectFit={
          'legacyStyles' in media && media.legacyStyles ? 'contain' : 'cover'
        }
      />
      {textBlock2 && <TextBlock text={textBlock2} />}
    </FlexColumn>
  );
};
